import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Person} from '../../class/person';

@Component({
  selector: 'app-person-button',
  templateUrl: './person-button.component.html',
  styleUrls: ['./person-button.component.css']
})
export class PersonButtonComponent implements OnInit {

  @Input()
  person: Person;

  @Output()
  onPersonSelected = new EventEmitter<Person>();

  constructor() {
  }

  ngOnInit() {
  }

  setSelectedPerson(person: Person) {
    this.onPersonSelected.emit(person);
  }

}
